<template>
<header v-if="allParksActive" class="container all-parks">
        <nav>
          <span>Disneyland Parks</span>
          <div class="right">
              <i @click="reloadApp" class="fas fa-sync"></i>
          </div>
      </nav>
</header>
<header v-else class="container day">
      <nav>
          <router-link class="router-link" :to="{name: 'AllParks'}">
          <div class="right">
            <i class="fas fa-arrow-circle-left"></i>
          </div>
          </router-link>
          <span>Disneyland Parks</span>
          <span>&deg;C</span>
      </nav>
  </header>
</template>

<script>
export default {
    name: "Navigation",
    props: ["allParksActive"],
    methods: {
         reloadApp() {
           location.reload();
       },
    }
};
</script>

<style lang="scss" scoped>
.all-parks{ 
    background: linear-gradient(to right, #3b8d99, #6b6b83, #aa4b6b); 
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    }
        
header {
    z-index: 99;
    position: fixed;
    max-width: 1024px;
    width: 100%;
    
    nav {
        display: flex;
        color: #fff;
        padding: 30px 0;
        justify-content: space-between;
    }
    
     .router-link {
        color: white;
    }
    
    .right {
        cursor: pointer;
        i {
            font-size: 24px;
        }
        
    }
    
    span {
        font-weight: 600;
        font-size: 24px;
    }
}
</style>
